import { render } from "./Card.vue?vue&type=template&id=2c538c2a&scoped=true"
const script = {}

import "./Card.vue?vue&type=style&index=0&id=2c538c2a&scoped=true&lang=css"

import exportComponent from "/pro/vue/Attamayyuz_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c538c2a"]])

export default __exports__